import { Container } from "@jds/core";
import { useRef, useState, useEffect } from "react";
import grtfestival from "../../images/greatindia.png";
import rotatebottles from "../../images/rotatebottle.png";
import colas from "../../images/cola.png";
import circles from "../../images/circle.png";
import vitas from "../../images/vita.png";
import ices from "../../images/ice.png";

import './Legacy.css';

const Legacy = () => {
    const colaRef = useRef(null);
    const [isColaVisible, setIsColaVisible] = useState(false);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsColaVisible(true);
            }
          });
        },
        { threshold: 0.5 }
      );
  
      if (colaRef.current) {
        observer.observe(colaRef.current);
      }
  
      const colaRefCurrentValue = colaRef.current;
  
      return () => {
        if (colaRefCurrentValue) {
          observer.unobserve(colaRefCurrentValue);
        }
      };
    }, []);
  
    return (
      <div>
        <Container
          className="complete"
          style={{
            minWidth: "100%",
            padding: "100px",
            background: "linear-gradient(180deg, #050f2c, #421c8d 36.98%)",
            justifyContent: "center",
            boxShadow: "120px 114px 50px 30px rgba(0, 0, 0, .05)",
            boxSizing: "border-box",
            zIndex: 4,
            position: "relative",
          }}
        >
          <div
            className="heightcheck"
            style={{
              height: "600px",
              borderRadius: "20px",
              color: "red",
              minWidth: "70%",
              boxShadow: "120px 114px 50px 30px rgba(0, 0, 0, .05)",
              display: "flex",
              flexDirection: "column",
              padding: "40px 26px 62px 62px",
              boxSizing: "border-box",
              background:
                "linear-gradient(180deg, #241f6e, #462897 40%, #6430b9 80%)",
              maxWidth: "1300px",
            }}
          >
            <h1
              className="small"
              style={{
                fontFamily: "LogikWide",
                // fontSize: '54px',
                fontSize: "clamp(24px, 5vw, 54px)",
                fontStyle: "italic",
                fontWeight: 700,
                lineHeight: "70px",
                background:
                  "linear-gradient(180deg, #fff, hsla(0, 0%, 100%, 0.4))",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textAlign: "center",
                marginTop: "15px",
                marginBottom: "50px",
              }}
            >
              A 50+ YEARS LEGACY
            </h1>
            <div
              id="responsiveDiv"
              style={{ display: "flex", flexDirection: "row", gap: "160px" }}
            >
              {/* First image with text below it */}
              <div>
                <img
                  className="festival"
                  src={grtfestival}
                  alt="grtfestival"
                  style={{ width: "222px", height: "294px" }}
                />
                <h5
                  className="smalltext"
                  style={{
                    paddingTop: "16px",
                    fontSize: "16px",
                    color: "#fff",
                    lineHeight: "18px",
                    fontFamily: "LogikWide",
                    padding: "16px 0px 0px",
                    textAlign: "left",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  One of the most iconic Indian brands, now <br />
                  reborn for modern India in a new avatar.
                </h5>
              </div>
  
              {/* Second image */}
              <div
                id="imagesContainer"
                style={{
                  position: "absolute",
                  right: "80%",
                  left: "65%",
                  width: "100px",
                  height: "300px",
                  //maxWidth: "800px",
                }}
              >
                <img
                  className="rotate"
                  ref={colaRef}
                  style={{
                    width: "195px",
                    height: "350px",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    zIndex: 4,
                    //animation: 'rotate-bottle 2s infinite',
                    animation: isColaVisible ? "rotate-bottle 2s " : "none",
                    animationIterationCount: 1,
                  }}
                  src={rotatebottles}
                  alt="RotatingBottle"
                />
                <img
                  alt="cola"
                  className="cola"
                  ref={colaRef}
                  src={colas}
                  style={{
                    width: "170px",
                    height: "250px",
                    position: "absolute",
                    top: "80px",
                    //right: '60%',
                    zIndex: 4,
                    right: "3%",
                    //  animation: 'rotate-bottle 2s infinite',
                    animation: isColaVisible ? "rotate-bottle 2s" : "none",
                    animationIterationCount: 1,
                  }}
                />
                <img
                  alt="circles"
                  className="circles"
                  ref={colaRef}
                  src={circles}
                  style={{
                    width: "380px",
                    height: "400px",
                    position: "absolute",
                    top: "2px",
                    //  top: '40px',
                    //right: '60%',
                    zIndex: 0.3,
                    left: "-100%",
                    //animation: 'rotate-bottle 2s infinite',
                    animation: isColaVisible ? "rotate-bottle 2s" : "none",
                    animationIterationCount: 1,
                  }}
                />
                <img
                  alt="vitas"
                  className="vitas"
                  ref={colaRef}
                  src={vitas}
                  style={{
                    width: "390px",
                    height: "350px",
                    position: "absolute",
                    top: "10px",
                    //  top: '40px',
                    //right: '60%',
                    zIndex: 1,
                    left: "-100%",
                    // animation: 'rotate-bottle 2s infinite',
                    animation: isColaVisible ? "rotate-bottle 2s" : "none",
                    animationIterationCount: 1,
                  }}
                />
  
                <img
                  alt="ice"
                  className="ice"
                  ref={colaRef}
                  src={ices}
                  style={{
                    width: "40px",
                    height: "46px",
                    position: "absolute",
                    top: "20px",
                    //  top: '40px',
                    //right: '60%',
                    zIndex: 0.3,
                    transform: "rotate(275deg)",
                    left: "10%",
                    //animation: 'rotate-bottle 2s infinite',
                    animationIterationCount: 1,
                    animation: isColaVisible ? "rotate-bottle 2s " : "none",
                  }}
                />
  
                <img
                  alt="ice2"
                  className="ice2"
                  ref={colaRef}
                  src={ices}
                  style={{
                    width: "30px",
                    height: "35px",
                    position: "absolute",
                    top: "90px",
                    //  top: '40px',
                    //right: '60%',
                    zIndex: 0.35,
                    filter: "blur(2px)",
                    transform: "rotate(275deg)",
                    left: "50%",
                    // animation: 'rotate-bottle 2s infinite',
                    animationIterationCount: 1,
                    animation: isColaVisible ? "rotate-bottle 2s " : "none",
                  }}
                />
  
                <img
                  alt="ice3"
                  className="ice3"
                  ref={colaRef}
                  src={ices}
                  style={{
                    width: "25px",
                    height: "35px",
                    position: "absolute",
                    top: "50px",
                    transform: "rotate(275deg)",
                    //  top: '40px',
                    //right: '60%',
                    zIndex: 2,
                    left: "180%",
                    // animation: 'rotate-bottle 2s infinite',
                    animationIterationCount: 1,
                    animation: isColaVisible ? "rotate-bottle 2s " : "none",
                  }}
                />
  
                <img
                  alt="ice4"
                  className="ice4"
                  ref={colaRef}
                  src={ices}
                  style={{
                    width: "25px",
                    height: "35px",
                    position: "absolute",
                    top: "150px",
                    //  top: '40px',
                    //right: '60%',
                    zIndex: 2,
                    filter: "blur(2px)",
                    left: "260%",
                    transform: "rotate(275deg)",
                    // animation: 'rotate-bottle 2s infinite',
                    animationIterationCount: 1,
                    animation: isColaVisible ? "rotate-bottle 2s " : "none",
                  }}
                />
  
                <img
                  alt="ice5"
                  className="ice5"
                  ref={colaRef}
                  src={ices}
                  style={{
                    width: "80px",
                    height: "60px",
                    position: "absolute",
                    top: "180px",
                    //  top: '40px',
                    //right: '60%',
                    transform: "rotate(275deg)",
                    zIndex: 0.3,
                    left: "180%",
                    //animation: 'rotate-bottle 2s infinite',
                    animationIterationCount: 1,
                    animation: isColaVisible ? "rotate-bottle 2s " : "none",
                  }}
                />
  
                <img
                  alt="ice6"
                  className="ice6"
                  ref={colaRef}
                  src={ices}
                  style={{
                    width: "40px",
                    height: "40px",
                    position: "absolute",
                    top: "340px",
                    filter: "blur(2px)",
                    //  top: '40px',
                    //right: '60%',
                    zIndex: 0.3,
                    transform: "rotate(210deg)",
                    left: "120%",
                    //  animation: 'rotate-bottle 2s infinite',
                    animationIterationCount: 1,
                    animation: isColaVisible ? "rotate-bottle 2s " : "none",
                  }}
                />
  
                <img
                  alt="ice7"
                  className="ice7"
                  ref={colaRef}
                  src={ices}
                  style={{
                    width: "40px",
                    height: "265x",
                    position: "absolute",
                    top: "260px",
                    //  top: '40px',
                    right: "90%",
                    zIndex: 0.1,
                    left: "-40%",
                    filter: "blur(2px)",
                    // animation: 'rotate-bottle 2s infinite',
                    animationIterationCount: 1,
                    animation: isColaVisible ? "rotate-bottle 2s " : "none",
                  }}
                />
  
                <img
                  alt="ice9"
                  className="ice9"
                  ref={colaRef}
                  src={ices}
                  style={{
                    width: "90px",
                    height: "50px",
                    position: "absolute",
                    top: "220px",
                    //  top: '40px',
                    right: "90%",
                    zIndex: 2,
                    left: "-110%",
  
                    //animation: 'rotate-bottle 2s infinite',
                    animationIterationCount: 1,
                    animation: isColaVisible ? "rotate-bottle 2s " : "none",
                  }}
                />
              </div>
            </div>
          </div>
        </Container>
        <style>
          {`
                 
                  `}
        </style>
      </div>
    );
  };

export default Legacy;